import React from 'react';
import { NavLink } from 'react-router-dom';

const services = [
    {
        count: 1,
        title: 'Doradztwo/Konsultacje',
        flaticon: 'flaticon-chart',
        description: 'Eksperckie doradztwo i pomoc w planowaniu idealnego skateparku.',
        link: '/doradztwo'
    },
    {
        count: 2,
        title: 'Projektowanie ',
        flaticon: 'flaticon-sketch',
        description: 'Innowacyjne i funkcjonalne projekty skateparków spełniające najnowsze standardy.',
        link: '/projektowanie'
    },
    {
        count: 3,
        title: 'Budowa',
        flaticon: 'flaticon-crane',
        description: 'Kompleksowa realizacja projektów skateparków, od fundamentów po ostateczne wykończenia.',
        link: '/budowa'
    },
    {
        count: 4,
        title: 'Przeglądy/Remonty',
        flaticon: 'flaticon-paint',
        description: 'Usługi serwisowe i modernizacyjne istniejących skateparków, zapewniające ich bezpieczeństwo i nowoczesność.',
        link: '/serwis'
    },
    {
        count: 5,
        title: 'Mobilne Przeszkody/Przydomowe Skateparki',
        flaticon: 'flaticon-decorating',
        description: 'Projektowanie i budowa mobilnych przeszkód oraz małych skateparków przydomowych.',
        link: '/mobilne'
    },
    {
        count: 6,
        title: 'Warsztat/Usługi CNC',
        flaticon: 'flaticon-drill',
        description: 'Precyzyjne usługi cięcia i obróbki CNC, dostosowane do specyficznych potrzeb naszych projektów.',
        link: '/cnc'
    }
];


var img1 = require('./../../images/background/bg-5.png');
var img2 = require('./../../images/background/line.png');

class AllServices2 extends React.Component {
    componentDidMount(){
        function loadScript(src) {
           
          return new Promise(function(resolve, reject){
            var script = document.createElement('script');
            script.src = src;
            script.addEventListener('load', function () {
              resolve();
            });
            script.addEventListener('error', function (e) {
              reject(e);
            });
            document.body.appendChild(script);
            document.body.removeChild(script);
          })
        };
 
      loadScript('./assets/js/masonary.js');
      
    };
    render() {
        return (
            <>
                <div className="section-full p-t80 p-b50 bg-white mobile-page-padding" style={{ backgroundImage: 'url(' + img1 + ')' }}>
                    <div className="container">
                        {/* TITLE START */}
                        <div className="section-head m-b50">
                                <div className="mt-separator-outer separator-left">
                                    <div className="mt-separator">
                                        <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">Od koncepcji</span> do Realizacji</h2>
                                    </div>
                                </div>
                                <h3>Zaangażowanie, pasja i wieloletnie doświadczenie w jeździe ekstremalnej kształtują każdy etap naszej pracy, od konsultacji społecznych, przez projektowanie, aż po wykonanie, tworząc skateparki, które spełniają marzenia i oczekiwania użytkowników.</h3>
                            </div>
                        {/* TITLE END */}
                        {/* IMAGE CAROUSEL START */}
                        <div className="section-content">
                            <div className="row">
                            {services.map((item, index) => (
                                <div key={index} className="col-md-4 col-sm-6">
                                    <div className="mt-icon-box-wraper p-a30 center m-b30 box-shadow bg-white">
                                        <div className="mt-icon-box-sm inline-icon text-primary  m-b20 radius bg-primary  scale-in-center bg-moving" style={{ backgroundImage: 'url(' + img2 + ')' }}>
                                            <span className="icon-cell text-secondry"><i className={item.flaticon} /></span>
                                        </div>
                                        <div className="icon-content">
                                            <h4 className="mt-tilte text-uppercase font-weight-600 m-b20">{item.title}</h4>
                                            <p>{item.description}</p>
                                            <NavLink to={item.link} className="site-button-link" data-hover="Więcej">Więcej <i className="fa fa-angle-right arrow-animation" /></NavLink>
                                        </div>
                                    </div>
                                </div>
                            ))}
                                
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default AllServices2;